import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CesDialogFooterComponent } from '../../ui/dialog-footer/dialog-footer.component';
import { ConfirmDialogA11yDirective } from '../../../directives/confirm-dialog-a11y.directive';

export interface BulkDeleteRow {
  label: string;
  detail?: string;
}

export interface BulkDeleteDialogData {
  title?: string;
  messageKey: string;
  toDeleteKey?: string;
  rows?: BulkDeleteRow[];
  count?: number;
}

@Component({
  selector: 'app-bulk-delete-confirmation',
  imports: [CommonModule, TranslocoModule, CesDialogFooterComponent, ConfirmDialogA11yDirective],
  templateUrl: './bulk-delete-confirmation.component.html',
})
export class BulkDeleteConfirmationComponent implements OnInit {
  private readonly config = inject<DynamicDialogConfig<BulkDeleteDialogData>>(DynamicDialogConfig);
  private readonly dialogRef = inject(DynamicDialogRef);

  title = '';
  messageKey = '';
  toDeleteKey: string | undefined;
  rows: BulkDeleteRow[] = [];
  count = 0;

  ngOnInit(): void {
    const data = this.config.data;
    if (!data) return;

    this.title = data.title ?? '';
    this.messageKey = data.messageKey;
    this.toDeleteKey = data.toDeleteKey;
    this.rows = data.rows ?? [];
    this.count = data.count ?? this.rows.length;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirmDeletion(): void {
    this.dialogRef.close(true);
  }
}
